import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import NoticeBar from 'components/NoticeBar'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors'
import { selectIsInKb } from 'selectors/location'
import { doFetchKnowledgeBases } from 'subapps/kb/actions/knowledge_bases'
import { selectKnowledgeBaseForInboxMigrationBanner } from 'subapps/kb/selectors/knowledge_bases'
import { doUpdateAccountPreference } from 'ducks/accountPreferences/operations'
import { selectAccountId } from 'ducks/accounts/selectors/selectAccountId'
import { doShowSnackbar } from 'actions/snackbar'
import storage from 'util/storage'
import styles from './styles.less'
import { styles as emotionStyles } from './styles'

const STORAGE_KEY_BASE = 'kb-migration-schedule-clicked'

export default function KbMigrationBanner() {
  const dispatch = useDispatch()
  const isManager = useSelector(selectCurrentUserIsAdminOrOwner)
  const isInKb = useSelector(selectIsInKb)
  const kbForBanner = useSelector(selectKnowledgeBaseForInboxMigrationBanner)
  const accountId = useSelector(selectAccountId)
  const storageKey = `${STORAGE_KEY_BASE}-${accountId}`
  const [hasClickedSchedule, setHasClickedSchedule] = useState(
    () => storage.get(storageKey) || false
  )

  // Always fetch KBs with forceGroove flag when component mounts on inbox pages
  // This ensures we have fresh migration status data
  useEffect(
    () => {
      if (!isInKb) {
        dispatch(doFetchKnowledgeBases())
      }
    },
    [dispatch, isInKb]
  )

  const handleDismiss = async () => {
    try {
      await dispatch(
        doUpdateAccountPreference('instantdocs_calendly_enabled', false)
      )
    } catch (error) {
      // Reset local state on failure to keep UI consistent
      setHasClickedSchedule(false)
      storage.set(storageKey, false)
      dispatch(
        doShowSnackbar(
          'Failed to dismiss banner. Please try again or contact support.'
        )
      )
    }
  }

  const handleScheduleMigration = () => {
    storage.set(storageKey, true)
    setHasClickedSchedule(true)
    window.open(
      'https://calendly.com/d/csnq-v65-7k7/instantdocs-onboarding',
      '_blank',
      'noopener,noreferrer'
    )
  }

  // Only show on inbox pages for managers when there's a KB to migrate
  // (Calendly enabled check is handled in the selector)
  if (!isManager || isInKb || !kbForBanner) {
    return null
  }

  return (
    <NoticeBar
      key="kb-migration-pending"
      type="warning"
      dismissible={hasClickedSchedule}
      onDismiss={handleDismiss}
    >
      <div css={emotionStyles.migrationContent}>
        <div css={emotionStyles.migrationText}>
          Your Groove Knowledge Base will be retired on Jan 1. Schedule your
          migration to InstantDocs today.{' '}
          <a
            href="https://www.groovehq.com/blog/groove-to-instantdocs-kb"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.demoBarLinkInlineWarning}
          >
            Learn more
          </a>
        </div>
        <button
          type="button"
          onClick={handleScheduleMigration}
          style={{
            marginLeft: 'var(--spacing-base)',
            cursor: 'pointer',
            color: 'var(--color-monochrome-black)',
            backgroundColor: 'white',
            border: '1px solid var(--color-monochrome-black)',
            padding: '6px 12px',
            borderRadius: '4px',
            fontSize: 'var(--fontSize-large)',
            fontWeight: 600,
            whiteSpace: 'nowrap',
          }}
        >
          Schedule Migration
        </button>
      </div>
    </NoticeBar>
  )
}
